import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";
import strFunc from "@/lib/lyg/string";
import ArrFunc from '@/lib/lyg/arr_func';

function CounselBox(props: any) {
  let myProps = {
    select_date: "",
    stu_info: {},
    Style: {},
    check_counsel_seq_arr: [],
    set_check_counsel_seq_arr: (inData: any) => { },
    stu_par_report_arr: [],
    is_exist_katalk_send: false,
    write_stu_par_report_by_ajax: (inData: any) => { },
    delete_stu_par_report_by_ajax: (inData: any) => { },
    ...props
  };
  let stu_info = myProps.stu_info;
  let Style = myProps.Style;
  let counsel_todo_arr = [];
  if (stu_info["counsel_todo_arr"]) {
    counsel_todo_arr = stu_info["counsel_todo_arr"];
  }
  let last_counsel_info: any = null;
  let counsel_pri_val = "";
  if (counsel_todo_arr && counsel_todo_arr.length > 0) {
    last_counsel_info = counsel_todo_arr[0];
  }
  if (stu_info["counsel_todo"]) {
    last_counsel_info = stu_info["counsel_todo"];
  }
  if (last_counsel_info != null) {
    counsel_pri_val = last_counsel_info["a_ymd"] + "," + last_counsel_info["a_seq"];
  }

  let is_checked_row = false;
  if (counsel_pri_val) {
    if (strFunc.str_in_array(counsel_pri_val, myProps.check_counsel_seq_arr) != -1) {
      is_checked_row = true;
    }
  }

  let stu_par_report: any = null;
  for (let i = 0; i < myProps.stu_par_report_arr.length; i++) {
    let row_report = myProps.stu_par_report_arr[i];
    if (row_report["a_stu_seq"] == stu_info["a_seq"]
      && row_report["a_date"] == myProps.select_date) {
      stu_par_report = row_report;
      break;
    }
  }

  const on_change_checkbox = (e: any) => {
    let tmp_arr = [...myProps.check_counsel_seq_arr];
    if (e.target.checked) {
      if (counsel_pri_val) {
        if (strFunc.str_in_array(counsel_pri_val, tmp_arr) == -1) {
          tmp_arr.push(counsel_pri_val);
        }
      }
    } else {
      tmp_arr = ArrFunc.get_remove_arr_by_value({
        arr: tmp_arr,
        except_val_arr: [counsel_pri_val]
      });
    }
    myProps.set_check_counsel_seq_arr(tmp_arr);
  };

  return (
    <div className={Style.card_box_con_box}>
      <div className={Style.right_top_con_box}>
        <label>
          <input type="checkbox" onChange={on_change_checkbox} checked={is_checked_row}
            style={{ width: "17px", height: "17px" }} />
        </label>
      </div>
      {last_counsel_info != null &&
        <>
          <div>
            {last_counsel_info["a_reserve_date"]} {last_counsel_info["a_kind"]}
            <span className="ml-1" style={{ color: "#666" }}>작성: {last_counsel_info["a_writer"]}</span>
            <span>
              {(stu_par_report == null&&myProps.is_exist_katalk_send) &&
                <button className="btn btn-dark ml-1"
                  onClick={() => {
                    myProps.write_stu_par_report_by_ajax({
                      select_counsel_info_arr: [last_counsel_info],
                    });
                  }}>리포트전송</button>
              }
              {stu_par_report &&
                <>
                  <span className={stu_par_report["a_is_read"] == "1" ? "success_color" : "ready_color" + " ml-1"}
                    style={{ display: "inline-block", padding: "0px 3px", borderRadius: "5px", color: "#fff" }}>
                    리포트 {stu_par_report["a_is_read"] == "1" ? "읽음" : "전송됨"}
                  </span>
                  <button className="btn btn-red ml-1"
                  onClick={() => {
                    myProps.delete_stu_par_report_by_ajax({
                      select_stu_par_report_arr: [stu_par_report],
                    });
                  }}>X</button>
                </>
              }
            </span>
          </div>
          <div className="mt-1" style={{ color: "gray" }}>
            {last_counsel_info["a_is_success"] == "1" ?
              <span style={{ color: "blue" }}>완료</span>
              :
              <span style={{ color: "gray" }}>준비</span>
            }
            <span className="ml-1">
              {last_counsel_info["a_sort1"]}
            </span>
          </div>
          <div className="mt-1">
            <MultyLineTextView text={last_counsel_info["a_content"]}></MultyLineTextView>
          </div>
          <div className="mt-1">
            <MultyLineTextView text={last_counsel_info["a_feedback"]}></MultyLineTextView>
          </div>
          {/* <div className="mt-1">
            <MultyLineTextView text={last_counsel_info["a_reference"]}></MultyLineTextView>
          </div> */}
        </>
      }
    </div>
  );
};
export default CounselBox;